import { Component, OnInit } from '@angular/core';
import {RecruitmentService} from "../../services/recruitment.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-recruitment',
  templateUrl: './recruitment.component.html',
  styleUrls: ['./recruitment.component.css', 'mobile.style.css']
})
export class RecruitmentComponent implements OnInit {

  constructor(private rService:RecruitmentService,private route: ActivatedRoute,
      private router: Router) { }

  isLoaded:boolean = false;

	menu:any;
  menuArray = [];
  newMenuArray = [];

  ngOnInit() {
  	this.rService.getMenu().subscribe((result:any)=>{
  		this.menu = result;
      let no = 1;
  		for(let key in this.menu){
  			this.rService.getContent(key).subscribe((result)=>{
          // let str = {'key':key,'value':this.menu[key],'content':result};
	  			let str = {'key':no,'value':this.menu[key],'content':result};
	  			this.menuArray.push(str);
          no++;
        })
      }
      console.log(this.menuArray);
      console.log(this.menu);
      for (var i = 0; i < this.menuArray.length; i++) {
        console.log(i);
        console.log("i");
      }
      this.isLoaded = true;
  	})

  }

  

}



// WEBPACK FOOTER //
// ./src/app/components/recruitment/recruitment.component.ts